const routes = [
	{
		path: '/',
		name: 'login',
		meta: {
			index: 0
		},
		component: () => import('@/views/Login/office')
	},
	{
		path: '/index',
		name: 'index',
		meta: {
			index: 0
		},
		redirect: '/home',
		component: () => import('@/views/Index'),
		children: [
			{
				path: '/home',
				name: 'home',
				meta: {
					index: 1,
					title: '主页',
					fatherContanier: 'content-wrap-1'
				},
				component: () => import('@/views/Home/office')
			},
			{
				path: '/userManage',
				name: 'userManage',
				meta: {
					index: 1,
					title: '用户管理'
				},
				component: () => import('@/views/UserManage')
			},
			{
				path: '/companyManage',
				name: 'companyManage',
				meta: {
					index: 1,
					title: '客户管理'
				},
				component: () => import('@/views/CompanyManage')
			},
			{
				path: '/deviceManage',
				name: 'deviceManage',
				meta: {
					index: 1,
					title: '设备管理'
				},
				component: () => import('@/views/DeviceManage')
			},
			{
				path: '/operateLog',
				name: 'operateLog',
				meta: {
					index: 1,
					title: '日志管理'
				},
				component: () => import('@/views/OperateLog')
			}
		]
	},
	{
		path: '/403',
		name: '403',
		meta: {
			index: 0
		},
		component: () => import('@/views/Error/403')
	},
	{
		path: '/404',
		name: '404',
		meta: {
			index: 0
		},
		component: () => import('@/views/Error/404')
	},
	{ path: '*', redirect: '/404' }
]
export default routes